<template>
  <div>
    <el-table :data="patentData.detail.applicantInfo" border style="width: 100%">
      <el-table-column prop="applicantInfoCountry" label="申请人国家">
      </el-table-column>
      <el-table-column prop="applicantInfoName" label="申请人姓名">
      </el-table-column>
      <el-table-column prop="applicantInfoType" label="申请人类型">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      patentData: null
    }
  },
  created() {

  },
  mounted() {
    this.patentData = this.data;
  },
  methods: {

  }
}
</script>

<style>

</style>